import script from "./SignupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=35447aa0&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35447aa0"]])

export default __exports__